/* eslint-disable no-console */
import React from "react";
import { PropTypes } from "prop-types";
import { ButtonContainer, StyledButton, StyledLink } from "./Button.styled";

const Button = ({
  noLink,
  backButtonText,
  backButtonVariant,
  continueButtonText,
  nextButtonDisabled,
  backButtonDisabled,
  isMobile,
  nextLink,
  backLink,
  onNextClick,
  onBackClick,
  hideNextButtonIcon,
}) => {
  return (
    <ButtonContainer>
      {noLink ? (
        <StyledButton
          data-cy="no-link-back-button"
          text={backButtonText}
          variant={backButtonVariant}
          isMobile={isMobile}
          backButtonDisabled={backButtonDisabled}
          onClick={onBackClick}
        />
      ) : (
        <StyledLink to={backButtonDisabled ? "#" : backLink}>
          <StyledButton
            data-cy="link-back-button"
            text={backButtonText}
            variant={backButtonVariant}
            isMobile={isMobile}
            backButtonDisabled={backButtonDisabled}
            onClick={onBackClick}
          />
        </StyledLink>
      )}
      {noLink ? (
        <StyledButton
          data-cy="no-link-next-button"
          text={continueButtonText}
          icon={!hideNextButtonIcon && "arrow-right"}
          disabled={nextButtonDisabled}
          isMobile={isMobile}
          onClick={onNextClick}
        />
      ) : (
        <StyledLink to={nextButtonDisabled ? "#" : nextLink}>
          <StyledButton
            data-cy="link-next-button"
            text={continueButtonText}
            icon={!hideNextButtonIcon && "arrow-right"}
            disabled={nextButtonDisabled}
            isMobile={isMobile}
            onClick={onNextClick}
          />
        </StyledLink>
      )}
    </ButtonContainer>
  );
};

Button.propTypes = {
  noLink: PropTypes.bool,
  backButtonVariant: PropTypes.string,
  backButtonText: PropTypes.string,
  continueButtonText: PropTypes.string,
  nextButtonDisabled: PropTypes.bool,
  backButtonDisabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  nextLink: PropTypes.string,
  backLink: PropTypes.string,
  onNextClick: PropTypes.func,
  onBackClick: PropTypes.func,
  hideNextButtonIcon: PropTypes.bool,
};

Button.defaultProps = {
  noLink: false,
  nextButtonDisabled: true,
  backButtonDisabled: false,
  backButtonText: "Back",
  continueButtonText: "Continue",
  backButtonVariant: "secondary",
  isMobile: false,
  nextLink: "#",
  backLink: "#",
  onNextClick: undefined,
  onBackClick: undefined,
  hideNextButtonIcon: false,
};

export default Button;
